import React, { useState, useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import { Box, Typography, LinearProgress, List, ListItem, ListItemText, Container, Stack, Button } from '@mui/material';
import { API } from '../conf';
import Header from './Header';

export default function RealTimeVote() {
    const containerRef = useRef(null)
    const [pour, setPour] = useState(0)
    const [contre, setContre] = useState(0)
    const [tt_votant, setTtVotant] = useState(217)
    const [loading, setLoading] = useState(true)

    const handleFullScreen = () => {
        if (containerRef.current) {
            // Demander à passer en plein écran
            containerRef.current.requestFullscreen().catch((err) => {
                console.error("Impossible d'activer le plein écran :", err);
            });
        }
    };

    async function reinitVote() {
        setLoading(true)
        fetch(API.concat('/vote/reset'), {method:'PATCH', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json'}
        }).then(async response =>{
            if(response.status !== 200) {
                console.log('Erreur lors de la réinitialisation')
            }
            setLoading(false)
        })
    }

    async function nextStep() {
        setLoading(true)
        fetch(API.concat('/vote/step'), {method:'PATCH', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json'},
            body:JSON.stringify({step:1})
        }).then(async response =>{
            if(response.status !== 200) {
                console.log('Erreur lors du passage à l\'étape suivante')
            }
            setLoading(false)
        })
    }

    useEffect(()=>{
        const socket = io(API, {
            path: '/socket.io/',
            transports: ['websocket'],
        })
        //recuperer les votes
        socket.emit('joinVote')
        socket.on('initVotes', data=>{     
            setPour(data.pour); setContre(data.contre)
            setLoading(false)
        })
        socket.on('updateVotes', data=>{
            setPour(data.pour)
            setContre(data.contre)
        })
        return ()=> socket.disconnect()
    }, [])

    return(
        <Box sx={{display:'flex', flexDirection:'column', height:'100vh'}}>
            <Header/>
            <Box display='flex' flexDirection='column' sx={{flex:1, marginY:'30px'}}>
                <Typography variant="h3" align="center">AGO {new Date().getFullYear()}</Typography>
                <Typography variant="h5" align="center">Vote en temps réel</Typography>
                <Button variant='contained' onClick={reinitVote} sx={{alignSelf:'flex-end', marginRight:5}}>Réinitialiser</Button>
                <Button variant='contained' onClick={nextStep} sx={{alignSelf:'flex-end', marginRight:5}}>Vote avis contraire</Button>
                {loading ? <Typography variant="h5" align="center">Chargement...</Typography>
                :<Button variant='contained' onClick={handleFullScreen} sx={{alignSelf:'flex-end', marginRight:5}}>FullScreen</Button>}
                {!loading && <Box ref={containerRef} display='flex' flexDirection='column' justifyContent='center' flex={1} sx={{paddingInline:5, backgroundColor:'white'}}>
                    <Stack direction='column' spacing={5} sx={{justifyContent:'center'}}>
                        <Typography variant="h1" fontSize='160px' align='center'>Pour: {pour}</Typography>
                        <Typography variant="h1" fontSize='160px' align='center'>Contre: {contre}</Typography>
                    </Stack>
                </Box>}
            </Box>
        </Box>
    )
}
